<template>
  <div id="dictionaryManagement" class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="12" class="h-full">
        <dicType @search="search" @clear="clear"></dicType>
      </el-col>
      <el-col :span="12" class="h-full">
        <dicItem ref="dicItem"></dicItem>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/babel">
import dicType from './components/DicType'
import dicItem from './components/DicItem'

export default {
  name: 'dictionaryManagement',
  components: { dicType, dicItem },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    search(id) {
      this.$refs.dicItem.dicTypeId = id
      this.$refs.dicItem.searchTableData()
    },
    clear(val) {
      if (val === 2) {
        this.$refs.dicItem.tableData = []
      }
    },
  },
  created() {},
}
</script>
